const platformNames = ['facebook', 'googleCalendar', 'googleMail', 'instagram', 'spotify', 'tiktok', 'twitter', 'youtube'] as const;

type PlatformName = (typeof platformNames)[number];

export { platformNames, PlatformName };
